import { render, staticRenderFns } from "./JobCards.vue?vue&type=template&id=f2161c92&"
import script from "./JobCards.vue?vue&type=script&lang=ts&"
export * from "./JobCards.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports